import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Service from './pages/Services';
import Contact from './pages/Contact';
import Navbar from "./components/Navbar";
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import BodyClassManager from './components/BodyClassManager'; // Opravený názov

import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="page-wrapper">
        <Navbar />
        <BodyClassManager /> {/* Toto pridá className na <body> */}
        
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/o-mne" element={<About />} />
            <Route path="/specializacia" element={<Service />} />   
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <CookieConsent />
    </Router>
  );
}

export default App;